import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const QUERY = gqlTagGira`
query JWMFieldDetails($cloudId: ID!, $projectId: ID!, $fieldId: String!) {
  jira {
    jwmCustomFieldDetails(cloudId: $cloudId, projectId: $projectId, fieldId: $fieldId) {
      fieldId
      name
      type
      description
      options(first: 100) {
        edges {
          node {
            optionId
            value
            isDisabled
            color {
              id
              colorKey
            }
          }
        }
      }
      configuration
      operations {
        editable
        removable
        deletable
        categoriesWhitelist
        canModifyRequired
        canModifyOptions
        canModifyDefaultValue
        canModifyPropertyConfiguration
        canAssociateInSettings
      }
    }
  }
}`;
